import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import SocialLinks from "../components/SocialLinks";

function AboutPage() {
  return (
    <Container fluid className="px-3 px-sm-5 mb-5">
      <Row>
        <h1>About Script Hive</h1>
        <p className="text-muted">Hello everyone,</p>

        <p className="text-muted">
          I'm Smish, the creator and manager of Script Hive. I started Script
          Hive over 10 years ago with a simple belief: screenplays should be
          free and accessible to everyone. Writers learn by reading, and I
          wanted to build a place where screenwriters—aspiring and professional
          alike—could study scripts, share knowledge, and grow together as a
          community.
        </p>

        <p className="text-muted">
          Since the beginning, Script Hive has been supported by an incredible
          network of writers and fans on Patreon. But to be transparent, it's
          also something I've been funding out of my own pocket all these years.
          Running a site like this comes with a lot of hidden costs: software,
          cloud storage (we currently host over 27,000 screenplays), bots, domains,
          hosting fees, and more. On top of that, a team of passionate
          volunteers has contributed hundreds of hours of unpaid work to help
          keep Script Hive alive and thriving.
        </p>

        <p className="text-muted">
          We've built something special together, and I'd love to keep it going
          for years to come. If Script Hive has ever helped you—whether you've
          learned from a script, found inspiration, or just enjoyed being part
          of the community—please consider joining us on Patreon. Every
          contribution goes directly toward covering the costs of running the
          site and ensuring that Script Hive can continue to be a free, open
          resource for screenwriters everywhere.
        </p>

        <p className="text-muted">
          Thank you for being part of this hive, and for supporting free access
          to screenwriting education.
        </p>

        <p className="text-muted">— Smish</p>
        <p className="text-muted">
          <Link to="https://patreon.com/scripthive" target="_blank">
            <button className="btn btn-primary">Become a supporter!</button>
          </Link>
        </p>
      </Row>
      <Row className="mt-4">
        <h2>Follow the Hive</h2>
        <SocialLinks />
      </Row>
      <Row className="mt-4">
        <h2>Notice to Rights Holders</h2>
        <p className="text-muted mt-3">
          Script Hive is a free educational resource created to help
          screenwriters study produced screenplays and improve their craft. We
          do not sell or monetize any material hosted or indexed on this site.
          All screenplays have been collected from publicly available sources
          across the internet over the past decade.
        </p>
        <p className="text-muted mt-3">
          Our intent is to preserve and share access for educational use only,
          in the same spirit as a library or academic archive. We believe
          studying screenplays is an essential part of learning the art and
          craft of screenwriting, and thousands of emerging writers have
          benefited from this collection.
        </p>
        <p className="text-muted mt-3">
          If you are a rights holder and would like a screenplay removed from
          Script Hive, please contact us at
          <a
            href="mailto:support@scripthive.com"
            className="text-decoration-none ms-1"
          >
            support@scripthive.com
          </a>
          . We honor all takedown requests immediately upon verification.
        </p>
        <p className="text-muted mt-3">
          Thank you for supporting the writing community and helping us maintain
          Script Hive as a respectful, educational space for screenwriters..
        </p>
      </Row>
    </Container>
  );
}
export default AboutPage;
